import HappeningImg from 'components/SharedComponents/HappeningImg/HappeningImg';

export default HappeningImg;
